import React from 'react';
import AutoCompleteField from '../../core/components/Fields/AutoCompleteField';
import { useAssistanceFieldContext } from '../pages/Assistance/AssistanceFieldContext';
import { renderFrameworkContractOption } from './useLookup';
import { FieldProps, useFieldProps } from '../pages/Assistance/customizable/Field';
import useForceSelectionLookupProps from './useForceSelectionLookupProps';
import useReselectEventListener from '../pages/Assistance/useReselectEventListener';
import StringField from '../../core/components/Fields/StringField';

export const FrameworkContractNumberField = (props: FieldProps) => {
    const { clientPartitionId, config } = useAssistanceFieldContext();
    const { lookupDefinitionId, lookupFieldName, allowInvalidIds } = config;

    const fieldProps = useFieldProps(props);
    const { value, onValueChange, onFocus, onBlur, onCommit } = fieldProps;

    const forceSelectionLookupProps = useForceSelectionLookupProps({
        lookupType: 'FrameworkContractLookupType',
        lookupDefinitionId,
        lookupFieldName,
        partitionId: clientPartitionId,
        allowInvalidIds,
        value,
        onValueChange,
        onUpdatePayloadChange: props.onUpdatePayloadChange,
        onFocus,
        onBlur,
        onCommit,
    });

    useReselectEventListener(props.inputRef, props.onReselect);

    // If no lookup is provided return this fiels as a StringField
    if (!lookupDefinitionId || !lookupFieldName) {
        return <StringField {...fieldProps} />;
    }

    return (
        <AutoCompleteField
            {...fieldProps}
            {...forceSelectionLookupProps}
            renderOption={renderFrameworkContractOption}
        />
    );
};

const FrameworkContractNameField = (props: FieldProps) => {
    const fieldProps = useFieldProps(props);

    return <StringField {...fieldProps} readOnly={true} disabled={true} />;
};

export const FrameworkContractNumberFieldConditionalComponents = [
    {
        condition: ({ fieldName }) => fieldName === 'framework_contract_number',
        component: FrameworkContractNumberField,
    },
    {
        condition: ({ fieldName }) => fieldName === 'framework_contract_name',
        component: FrameworkContractNameField,
    },
];
